import { withStyles } from '@material-ui/core'

import { SourceListItemBase } from './SourceListItem'

import { styles } from './styles'

export const SourceListItem = withStyles(styles)(SourceListItemBase)



// WEBPACK FOOTER //
// ./src/components/Sources/components/SourceListItem/index.js